import { useAuth } from "hooks/Auth";
import React, { useState, useEffect, useCallback } from "react";
import { apiGet } from "helpers/Request";
import { transform as collectionTransformer } from "schemas/Collection";
import exclaims from "assets/exclaims.json";
import { arrayRandom } from "Utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { thin } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useContextualHelp } from "hooks/Help";

export default function CollectionBrowser(props) {
    const [collections, setCollections] = useState([]);
    const auth = useAuth();
    const contextualHelp = useContextualHelp();

    const loadCollections = useCallback(() => {
        apiGet("/v4/collection", auth.publication, {
            sort: "name",
            order: "asc",
            limit: 200,
        }).then((resp) => {
            setCollections(collectionTransformer(resp));
        });
    }, [auth.publication]);

    useEffect(() => {
        loadCollections();
    }, [loadCollections]);

    return (
        <div className="px-2 sm:px-0">
            <hr className="my-4" />
            <h2 className="text-xl font-semibold text-gray-800">
                Or, Browse Collections
            </h2>
            {collections.length ? (
                <div className="mt-4 grid grid-cols-4 gap-4 rounded-md bg-white p-4 text-center align-bottom shadow-sm sm:grid-cols-8">
                    {collections.map((collection) => (
                        <Link
                            className="text-center"
                            to={`/app/dashboard?collection=${collection.id}`}
                        >
                            <FontAwesomeIcon
                                className="mx-auto block text-5xl text-green-600"
                                icon={thin("folder")}
                            />
                            <div className="text-sm text-gray-700">
                                {collection.name}
                            </div>
                        </Link>
                    ))}
                </div>
            ) : (
                <div className="mt-4 space-y-4 rounded-md bg-white p-4 text-center shadow-sm">
                    <FontAwesomeIcon
                        className="text-5xl text-gray-300"
                        icon={thin("folder-open")}
                    />
                    <div className="text-xl font-bold">
                        {arrayRandom(exclaims)}
                    </div>
                    <hr />
                    <div className="text-sm font-normal tracking-tighter">
                        You don't have any collections yet!{" "}
                        <button
                            type="button"
                            className="cursor-help text-green-600 underline"
                            onClick={() =>
                                contextualHelp.showContextualHelp(
                                    "/search/collections.html"
                                )
                            }
                        >
                            How do I add a collection?
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
